/**
 * useChatSounds — Sons de chat via Web Audio API
 * Extraído de Chat.tsx e ChatHubPage.tsx (código duplicado)
 */
import { Signal } from '@preact/signals';

const audioCtxRef = { ctx: null as AudioContext | null };

function getAudioCtx(): AudioContext {
  if (!audioCtxRef.ctx) audioCtxRef.ctx = new AudioContext();
  if (audioCtxRef.ctx.state === 'suspended') audioCtxRef.ctx.resume();
  return audioCtxRef.ctx;
}

/**
 * Retorna funções de som para chat.
 * @param enabled - Signal<boolean> que controla se sons estão ativos
 */
export function useChatSounds(enabled: Signal<boolean>) {
  function playSendSound() {
    if (!enabled.value) return;
    const ctx = getAudioCtx();
    // Pop ascendente rápido — estilo WhatsApp/Telegram
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain); gain.connect(ctx.destination);
    osc.type = 'sine';
    osc.frequency.setValueAtTime(800, ctx.currentTime);
    osc.frequency.exponentialRampToValueAtTime(1200, ctx.currentTime + 0.08);
    gain.gain.setValueAtTime(0.15, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.12);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + 0.12);
  }

  function playReceiveSound() {
    if (!enabled.value) return;
    const ctx = getAudioCtx();
    // Tom duplo descendente suave — estilo iMessage/Telegram
    [0, 0.1].forEach((delay, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain); gain.connect(ctx.destination);
      osc.type = 'sine';
      osc.frequency.setValueAtTime(i === 0 ? 880 : 660, ctx.currentTime + delay);
      gain.gain.setValueAtTime(0.12, ctx.currentTime + delay);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + delay + 0.15);
      osc.start(ctx.currentTime + delay);
      osc.stop(ctx.currentTime + delay + 0.15);
    });
  }

  return { playSendSound, playReceiveSound };
}
